import {CareJourneyDetailsResponse, CareJourneyStep} from "@/api/dto/care-journey";
import {ClientProfile} from "@/api/dto/client-profile";
import AppointmentCard from "@/components/pages/tasks/task_edit/progress/bh_journey/AppointmentCard";

type Props = {
    careJourneyStep: CareJourneyStep;
    readOnly: boolean;
    careJourneyDetails: CareJourneyDetailsResponse;
    patient: ClientProfile;
}

const ScheduleAppointmentsStep = (props: Props) => {

  return <>
    {props.careJourneyStep.appointments?.map(appointment =>
      <AppointmentCard
        parentJourney={props.careJourneyDetails}
        key={appointment.careJourneyInstanceId}
        appointment={appointment}
      />
    )}
  </>;
};

export default ScheduleAppointmentsStep;
